export default __webpack_public_path__ + "static/media/landing_page_reference_1.e5a29e97.png";